import React from 'react';
import { asBlob } from 'html-docx-js-typescript';
import axios from 'axios';
import HamsterAnimation from '../animation/loader';

const ConvertToPdfButton = ({ input }) => {
  const [loading, setLoading] = React.useState(false);
  const convertToPdf = async () => {
    try {
      // Convert HTML string to Blob (DOCX)
      setLoading(true);
      const htmlContent = `<!DOCTYPE html><html><head><meta charset="UTF-8"></head><body>${input}</body></html>`;
      const blob = await asBlob(htmlContent);

      const publicKey = process.env.REACT_APP_API_IPF; // Replace with your actual public key

      // Step 1: Authenticate and get a token
      const authResponse = await axios.post('https://api.ilovepdf.com/v1/auth', { public_key: publicKey });
      const token = authResponse.data.token;
      console.log("token:",token);
      // Step 2: Start a task
      const startResponse = await axios.get('https://api.ilovepdf.com/v1/start/officepdf', {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("startResponse:",startResponse);
      const { server, task } = startResponse.data;

      // Step 3: Upload the file
      const formData = new FormData();
      formData.append('task', task);
      //formData.append('server', server);
      formData.append('file', blob, 'document.docx');
      const uploadResponse = await axios.post(`https://${server}/v1/upload`, formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("upload post response:",uploadResponse);
      const uploadData = uploadResponse.data;
      const serverFilename = uploadData.server_filename;
      // Step 4: Process the task
      const processResponse = await axios.post(`https://${server}/v1/process`, {
        task,
        tool: 'officepdf',
        files: [{ server_filename: serverFilename , filename: 'document.docx'}]
      }, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("process post response:",processResponse);

      // Step 5: Download the processed file
      const downloadResponse = await axios.get(`https://${server}/v1/download/${task}`, {
        headers: { Authorization: `Bearer ${token}` },
        responseType: 'blob',
      });

      // Create a URL for the received PDF blob
      const pdfUrl = window.URL.createObjectURL(new Blob([downloadResponse.data], { type: 'application/pdf' }));

      // Download the file
      const downloadAnchor = document.createElement('a');
      downloadAnchor.href = pdfUrl;
      downloadAnchor.download = 'converted_document.pdf';
      document.body.appendChild(downloadAnchor);
      downloadAnchor.click();

      // Clean up
      document.body.removeChild(downloadAnchor);
      window.URL.revokeObjectURL(pdfUrl);
      setLoading(false);
    } catch (error) {
      console.error('Error during PDF conversion:', error);
      setLoading(false);
    }
  };

  return <>
  <button className='content-button status-button open' onClick={convertToPdf} disabled={loading}>Convert to PDF</button>
  {loading && <HamsterAnimation />}
  </>;
};

export default ConvertToPdfButton;
